/* eslint global-require: 0 */
import React from 'react';
import { render } from 'react-dom';
import { AppContainer } from 'react-hot-loader';
import 'babel-polyfill';
/* Date polyfill */
import 'classlist-polyfill';
import 'date-input-polyfill';

/* Polyfill for fetch */
import 'whatwg-fetch';

// import Routes from './routes';
import Root from './containers/Root';
import configureStore from './store/configureStore';

require('./styles/main.scss');
require('./utils/ie.js');

const store = configureStore();

const runApp = () => {
  render(
    <AppContainer>
      <Root
        store={store}
      />
    </AppContainer>,
    document.getElementById('app'),
  );

  if (module.hot) {
    module.hot.accept('./containers/Root', () => {
      const RootContainer = require('./containers/Root').default;

      render(
        <AppContainer>
          <RootContainer
            store={store}
          />
        </AppContainer>,
        document.getElementById('app'),
      );
    });
  }
};

if (!global.Intl) {
  require.ensure([
    'intl',
    'intl/locale-data/jsonp/en.js',
    'intl/locale-data/jsonp/is.js',
  ], (require) => {
    require('intl');
    require('intl/locale-data/jsonp/en.js');
    require('intl/locale-data/jsonp/is.js');
    runApp();
  });
} else {
  runApp();
}



// WEBPACK FOOTER //
// ./src/index.js